const ACRE_MM_TO_LITERS = 4046.856;

const KC = {
  rice:   { initial: 1.10, mid: 1.20, late: 0.95 },
  wheat:  { initial: 0.70, mid: 1.15, late: 0.55 },
  tomato: { initial: 0.60, mid: 1.15, late: 0.80 },
  potato: { initial: 0.50, mid: 1.15, late: 0.75 },
};

export function calculateWaterRequirement({
  crop,
  areaAcres,
  ETo,
  stage = "mid",
  efficiency = 0.7,
  effectiveRain = 0,
}) {
  if (!KC[crop]) throw new Error("Unsupported crop");
  if (!(stage in KC[crop])) throw new Error("Invalid stage");
  if (areaAcres <= 0) throw new Error("Area must be > 0");
  if (ETo <= 0) throw new Error("ETo must be > 0");

  const kc = KC[crop][stage];
  const ETc = kc * ETo;
  const netIrrigation = Math.max(ETc - effectiveRain, 0);
  const grossIrrigation = netIrrigation / efficiency;
  const dailyLiters = grossIrrigation * areaAcres * ACRE_MM_TO_LITERS;

  return {
    dailyLiters: Math.round(dailyLiters),
    weeklyLiters: Math.round(dailyLiters * 7),
    ETc_mm_per_day: Math.round(ETc * 100) / 100,
    grossIrrigation_mm_per_day: Math.round(grossIrrigation * 100) / 100,
  };
}